import { Link } from 'react-router-dom';

import { MarkerIcon } from './SvgComponents/MarkerIcon';

export const Footer = () => (
  <footer className="w-full bg-background">
    <div className="py-5 px-10 lg:px-24 m-auto flex flex-col table:flex-row justify-center gap-10 lg:gap-20 2xl:justify-between items-center max-w-108">
      <div className="flex flex-col gap-3">
        <p className="font-poppins text-font font-normal text-sm tracking-widest leading-7 text-center">
          All rights are reserved for JK Rowling and Warner Bros. ©
        </p>
        <hr className="h-0.5 w-90 border-none bg-gradient-to-r from-grStart to-grEnd" />
        <Link
          className="flex justify-center items-center font-poppins text-font font-normal text-sm tracking-widest leading-7 text-center hover:text-hover duration-300"
          to="/map">
          <MarkerIcon />
          Visit us alive!
        </Link>
      </div>
      <img className="w-auto h-10" src="/Assets/Icons/Potter.svg" alt="Potter Logo" />
      <div className="flex flex-col gap-3">
        <p className="font-poppins text-font font-normal text-sm tracking-widest leading-7 text-center">
          All materials are used just for educational purposes
        </p>
        <hr className="h-0.5 w-90 border-none bg-gradient-to-l from-grStart to-grEnd" />
        <p className="font-poppins text-font font-normal text-sm tracking-widest leading-7 text-center">
          Created by&nbsp;
          <a className=" hover:text-hover duration-300" href="https://github.com/PavelTitov16">
            Pavel Tsitou
          </a>
        </p>
      </div>
    </div>
  </footer>
);
